<mat-toolbar color="primary">
    <span>Problèmes</span>
    <button (click)="newProblem()" mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>note_add</mat-icon>
    </button>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>search</mat-icon>
    </button>    
</mat-toolbar>
<app-problem-table #problemtable [location]="'panel'"></app-problem-table>